module.exports = __webpack_public_path__ + "static/media/Parsian.de12be44.svg";